module.exports = __webpack_public_path__ + "static/media/ENGINE W HOSES-1200-AdobeStock_45842348.bff76666.png";